/**
 * Перенос `Nullable<T>` из `flutter_toolkit`.
 *
 * В `copyWith` нельзя отличить «поле не передали» от «передали null»:
 * и то и другое приходит как `undefined`/`null`. Обёртка решает это —
 * `undefined` значит «не трогать», `new Nullable(null)` значит «обнулить».
 */
export class Nullable<T> {
  constructor(readonly value: T) {}
}

/** `field == null ? this.field : field.value` из Dart-кода. */
export function resolveNullable<T>(
  wrapper: Nullable<T> | undefined,
  currentValue: T,
): T {
  return wrapper === undefined ? currentValue : wrapper.value;
}
